// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2020-10-06 12:14:59 +0200 (Tue, 06 Oct 2020) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 113976 $
//  Purpose   : preservation jobs
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import log from 'uix/logging'
import {sum} from 'ldash'
import {prettyBytes} from 'uix/utils'

// ---Exports
const formatCountSizeError = (evt, verb) => {
  if (evt) {
    let errors = evt.errcount ? `(${evt.errcount} Fehler)` : ''
    let bytes = evt.filesize ? ` mit ${prettyBytes(evt.filesize)}` : ''
    return `${evt.count} Kapsel(n)${bytes} ${verb} ${errors}`
  }
  return null
}

export const ZipExportCombinedJob = {
  compact: ({eventTypes}) => {
    let created = formatCountSizeError(eventTypes['capsules created']?.[0], 'erstellt')
    let transfered = formatCountSizeError(eventTypes['capsules transfered']?.[0], 'transferiert')
    if (!created) return null
    if (transfered) {
      return `${created}, ${transfered}`
    }
    return created
  },
}

export const ZipExportJob = {
  compact: ({eventTypes}) => {
    let created = eventTypes['zip capsule created'] || []
    let filesize = sum(created.map(e => e.filesize))
    let errors = eventTypes.error?.length > 0 ? `(${eventTypes.error.length} Fehler)` : ''
    return `${created.length} Kapsel(n) mit ${prettyBytes(filesize)} erstellt ${errors}`
  },
  //~ report: ({messages, byType}) => {
  //~ return <div>XXX</div>
  //~ },
}

//~ export const DomainCapsuleJob = {
//~ compact: ({}) => {
//~ return <>XXX</>
//~ },
//~ report: ({}) => {
//~ return <div>XXX</div>
//~ },
//~ }

export const ManualExport = {
  compact: ({eventTypes}) => formatCountSizeError(eventTypes['capsules created']?.[0], 'erstellt'),
}
